import { AfterModelInit, Cast, CastType, IDataModel, Ignore, Model } from '@klickdata/core/application';
import { Prop } from '@klickdata/core/form';
import { Media } from '@klickdata/core/media/src/media.model';
import { ResourceTag, ResourceTagData } from '@klickdata/core/resource';
import { Feeds, Medias } from '@klickdata/core/resource/src/resource.model';
import { User } from '@klickdata/core/user';
import { Utils } from '@klickdata/core/util';
import { Observable } from 'rxjs';

export interface FileData extends IDataModel {
    id: number;
    description?: string;
    title?: string;
    tags?: ResourceTagData[];
    tag_ids?: number[];
    created_at?: string;
    url?: string;
    visibility?: string;
    author?: {};
    created_by?: number;
    medias?: Medias;
    downloads?: {};
    priority?: string;
    files$?: Observable<Media[]>;
    user_feeds?: Feeds;
    favorite?: boolean;
    user_ids?: number[];
    customer_ids?: number[];
    group_ids?: number[];
    managers?: any[];
    staff?: any;
}

export class File extends Model<FileData> implements AfterModelInit {
    id: number;
    description: string;
    title: string;
    tags: ResourceTag[];
    tag_ids: number[];
    created_by: number;
    url: string;
    @Prop()
    visibility: string;
    public created_at: moment.Moment;
    author$: Observable<User>;
    @Cast(CastType.CLOSURE, Utils.filterUpdatedObject)
    public medias: Medias;
    priority: string;
    @Ignore()
    downloads: {};
    @Ignore()
    files$: Observable<Media[]>;
    @Ignore()
    user_feeds: Feeds;
    user_ids: number[];
    group_ids: number[];
    customer_ids: number[];
    @Ignore()
    managers: any[];
    get favorite(): boolean {
        return this.user_feeds?.favorite;
    }

    set favorite(favorite: boolean) {
        this.user_feeds = { ...this.user_feeds, favorite };
    }

    afterModelInit(data: FileData): void {
        if (data.tags) {
            this.tags = data.tags.map((tagData) => new ResourceTag(tagData));
        }
    }
}
